export default "__VITE_ASSET__CPn1HwrO__"